module.exports = __webpack_public_path__ + "static/media/test9_4.e79b4fcd.png";